module.exports = __webpack_public_path__ + "img/duels.48e7b8d3.svg";